const e = "Conta", a = "Conta", o = "Descrição da conta", t = "ID da conta", n = "Adições", s = "Ajustes", r = "Valor", i = "e", c = "Aplicar", d = "Voltar", l = "Conta de saldo", u = "ID da conta do saldo", p = "Reservado", m = "Capturado", f = "Categoria", g = "Chargebacks", h = "Fechar", v = "Contate o suporte", b = "Procure o suporte para obter ajuda.", y = "Entre em contato com o suporte para obter ajuda e compartilhe o código de erro %{requestId}", T = "Copiado", A = "Copiar", R = "Correções", C = "Moeda", P = "Data", N = "Intervalo de datas", O = "Descrição", x = "Descartar", F = "Baixar", S = "Baixando", D = "E-mail", q = "Entidade não encontrada", I = "Transação não encontrada para o titular da conta especificado", V = "Taxas", w = "Arquivo", E = "Barra de filtro", L = "De", B = "Cheio", k = "Fundos capturados", W = "voltar", M = "Subsídio emitido", U = "Reembolsos de subsídios", j = "Ocultar conteúdo", z = "ID", Y = "Campo incompleto", H = "Em andamento", _ = "Carregando", G = "máx.", X = "min", Q = "Celular", J = "Repasse do pagamento líquido", K = "Próximos repasses do pagamentos", Z = "Sem dados", $ = "Números negativos não são permitidos", ee = "Nenhum repasse do pagamento encontrado", ae = "Nenhum relatório encontrado", oe = "Nenhuma transação encontrada", te = "Outros", ne = "Navegação por página", se = "Parcial", re = "ID do pagamento", ie = "Método de pagamento", ce = "Detalhes do repasse do pagamento", de = "As informações de repasse do pagamento são geradas todos os dias à meia-noite, horário UTC.", le = "Liquidação", ue = "Pendente", pe = "Volte depois.", me = "Entre em contato com o suporte para obter assistência.", fe = "Entre em contato com o suporte", ge = "ID de referência", he = "Atualizar", ve = "Reembolsos", be = "Reembolsar pagamento", ye = "Não foi possível processar o reembolso. Tente novamente mais tarde.", Te = "Ocorreu algum erro.", Ae = "Seu cliente receberá o dinheiro em no máximo 40 dias. Quando o reembolso for realizado, você verá uma nova transação de reembolso na sua lista.", Re = "Reembolso enviado!", Ce = "Valor a ser reembolsado", Pe = "Os reembolsos podem levar até 40 dias, dependendo do método de pagamento. As taxas estão incluídas.", Ne = "Reembolsar %{amount}", Oe = "Motivo do reembolso", xe = "Referência", Fe = "Valor restante", Se = "Relatório", De = "Os relatórios são gerados todos os dias à meia-noite, horário UTC.", qe = "Relatórios", Ie = "Reiniciar", Ve = "Revertido", we = "Ocorreu algum erro.", Ee = "Algo deu errado. Tente atualizar a página, ou volte mais tarde.", Le = "Status", Be = "Lista estruturada", ke = "Subtrações", We = "Soma dos pagamentos do mesmo dia", Me = "Abas", Ue = "Código de erro: %{requestId}", je = "Não há resultados", ze = "A solicitação não apresenta alguns campos obrigatórios, ou contém dados inválidos.", Ye = "Ocorreu um erro inesperado", He = "A conta selecionada está incorreta", _e = "Fuso horário", Ge = "Até", Xe = "Total de entrada", Qe = "Total de saída", Je = "O valor deve ser igual ou maior que o valor em Origem", Ke = "Detalhes da transação", Ze = "Transações", $e = "Visão geral das transações", ea = "Tipo de transação", aa = "Transferências", oa = "Tente uma pesquisa diferente ou redefina seus filtros para tentarmos novamente.", ta = "Tente atualizar a página, ou volte mais tarde.", na = "Valor", sa = "Tipo", ra = "Valor", ia = "Não foi possível carregar a visão geral dos repasses de pagamentos.", ca = "Não foi possível carregar a visão geral dos relatórios.", da = "Não foi possível carregar a visão geral das transações.", la = "Não foi possível carregar suas contas.", ua = "Não foi possível carregar seus repasses de pagamentos.", pa = "Não foi possível carregar seus relatórios.", ma = "Não foi possível carregar suas transações.", fa = {
  account: e,
  accountBalance: a,
  accountDescription: o,
  accountID: t,
  additions: n,
  adjustments: s,
  amount: r,
  and: i,
  apply: c,
  back: d,
  balanceAccount: l,
  balanceAccountId: u,
  Booked: p,
  "button.clearAll": "Limpar tudo",
  "calendar.controls": "Controles de navegação do calendário",
  "calendar.nextMonth": "Próximo mês",
  "calendar.previousMonth": "Mês anterior",
  "calendar.timezone": "O fuso horário está definido em: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Sua conta está inativa",
  "capital.actionNeeded": "Ação necessária",
  "capital.bankAccountDetails": "Dados da conta bancária",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "número da conta",
  "capital.bankCountryOrRegion": "País/região",
  "capital.bankRoutingNumber": "Número de roteamento",
  "capital.bankSortCode": "Código de classificação",
  "capital.businessFinancing": "Financiamento de negócios",
  "capital.businessFinancingOffer": "Oferta de financiamento de negócios",
  "capital.businessFinancingSummary": "Resumo do financiamento de negócios",
  "capital.closed": "Fechado",
  "capital.couldNotContinueWithTheOffer": "Não foi possível continuar com a oferta.",
  "capital.couldNotLoadFinancialOffers": "Não foi possível carregar as ofertas de financiamento.",
  "capital.dailyRepaymentRate": "Taxa de pagamento da prestações diário",
  "capital.daysAndDaysLeft": "%{days} dias (%{daysLeft} dias restantes)",
  "capital.expectedRepaymentPeriod": "Período de pagamento da prestações esperado",
  "capital.failed": "Falha",
  "capital.fees": "Taxas",
  "capital.fullyRepaid": "Quitado",
  "capital.goToTermsAndConditions": "Ir para Termos e condições",
  "capital.grantID": "ID do subsídio",
  "capital.howMuchMoneyDoYouNeed": "De quanto dinheiro você precisa?",
  "capital.inProgress": "Em andamento",
  "capital.legalSubtitleAU": "Adyen Capital é fornecido pela Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Os empréstimos são concedidos pela Adyen N.V.",
  "capital.legalSubtitleGB": "Os empréstimos são concedidos pela Adyen N.V. representada por sua filial de Londres.",
  "capital.legalSubtitleUS": "Os empréstimos são concedidos pela Adyen N.V., filial de São Francisco, e estão sujeitos à aprovação de crédito.",
  "capital.maximumRepaymentPeriod": "Período máximo do pagamento da prestações",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Pagamento mínimo a cada %{days} dias para pagar o financiamento em dia",
  "capital.needSomeExtraMoney": "Precisa de dinheiro extra?",
  "capital.offerLegalNoticeDescriptionUS": "Se sua solicitação de crédito empresarial for negada, você tem o direito de receber uma declaração por escrito com os motivos específicos da recusa. Para obter essa declaração, entre em contato com a equipe de suporte de crédito da Adyen pelo e-mail %{email} dentro de 60 dias a partir da data em que tomar conhecimento de nossa decisão. Enviaremos a você uma declaração por escrito com os motivos da recusa dentro de 30 dias após recebermos sua solicitação. %{break} A Lei Federal de Igualdade de Oportunidade de Crédito (Equal Credit Opportunity Act) proíbe os credores de discriminar os solicitantes de crédito com base em raça, cor, religião, origem nacional, sexo, estado civil, idade (desde que o solicitante tenha a capacidade legal de firmar um contrato vinculativo), porque toda ou parte da renda do solicitante deriva de qualquer programa de assistência pública ou porque o solicitante exerceu de boa fé qualquer direito sob a Lei de Proteção ao Crédito ao Consumidor (Consumer Credit Protection Act). A agência federal que administra a conformidade com esta lei em relação a este credor é o Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Credor: Adyen N.V. – Filial de San Francisco %{break} 505 Brannan Street, São Francisco, CA 94107.",
  "capital.oneMonth": "1 mês",
  "capital.pending": "Pendente",
  "capital.primaryAccount": "Conta principal",
  "capital.remaining": "Restante(s)",
  "capital.remainingAmount": "Valor restante",
  "capital.remainingFees": "Taxas restantes",
  "capital.repaid": "Reembolsado",
  "capital.repaidAmount": "Valor pago",
  "capital.repaidFees": "Taxas pagas",
  "capital.repaymentBalanceInfo": "Seu valor restante atual, incluindo taxas, é %{amount}",
  "capital.repaymentThreshold": "Limite do pagamento de prestações",
  "capital.requestedFunds": "Fundos solicitados",
  "capital.requestFunds": "Solicitar fundos",
  "capital.requesting": "Solicitando",
  "capital.reviewOffer": "Revisar oferta",
  "capital.revoked": "Revogado",
  "capital.seeNewOffer": "Ver nova oferta",
  "capital.seeOptions": "Ver opções",
  "capital.sendRepayment": "Enviar pagamento da prestação",
  "capital.sendRepaymentNotice": "A transferência bancária complementar feita para o seu empréstimo pode levar de dois a três dias úteis para entrar na sua conta de empréstimo.",
  "capital.sendRepaymentSubtitle": "Transfira dinheiro para esta conta bancária para pagar parte ou a totalidade do seu empréstimo.",
  "capital.signTermsAndConditionsToReceiveFunds": "Assine os Termos e condições para receber seus fundos.",
  "capital.signTheTermsToReceiveYourFunds": "Assine os termos para receber seus fundos",
  "capital.termEnds": "O prazo termina: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Não há uma conta primária configurada",
  "capital.thisOfferExpiresOn": "Esta oferta vence em %{date}.",
  "capital.totalFees": "Total de taxas",
  "capital.totalRepaymentAmount": "Valor total do pagamento de parcelas",
  "capital.unsupportedRegionDescription": "O financiamento de negócios ainda não está disponível na sua região, mas volte aqui para conferir uma oferta.",
  "capital.unsupportedRegionTitle": "Aguarde!",
  "capital.weCouldNotContinueWithTheOffer": "Não foi possível continuar com a oferta.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Não foi possível continuar com a oferta. Procure o suporte para obter ajuda.",
  "capital.weCouldNotLoadFinancialOffers": "Não foi possível carregar as ofertas de financiamento.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Não foi possível processar essa solicitação. Tente novamente com uma nova oferta.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Recebemos sua solicitação e estamos analisando. Volte em breve para mais informações.",
  "capital.writtenOff": "Dívida cancelada",
  "capital.xDays": "%{days} dias",
  "capital.xMonths": "%{months} meses",
  "capital.xPercent": "%{percentage}%",
  "capital.youAcceptedButThenReturnedTheseFunds": "Você aceitou, mas depois devolveu esses fundos",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Você aceitou esses fundos, mas não pagou as parcelas",
  "capital.youAreRequestingFundingOf": "Você está solicitando financiamento de",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Você foi pré-qualificado para o financiamento de negócios",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " até %{amount}.",
  "capital.yourRequestedFundsWere": "Seus fundos solicitados foram: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Você deve receber os fundos em um dia útil",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Você precisará pagar uma parcela mínima de %{amount} a cada %{days} dias para quitar o financiamento até %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Em breve você se qualificará para uma oferta de financiamento!",
  capture: m,
  category: f,
  chargeback: g,
  closeIconLabel: h,
  contactSupport: v,
  contactSupportForHelp: b,
  contactSupportForHelpAndShareErrorCode: y,
  copied: T,
  copy: A,
  correction: R,
  currency: C,
  date: P,
  dateRange: N,
  default: "Padrão",
  description: O,
  dismiss: x,
  download: F,
  downloading: S,
  email: D,
  entityWasNotFound: q,
  entityWasNotFoundDetail: I,
  "error.pleaseTryAgainLater": "Tente novamente depois.",
  "error.somethingWentWrongWithDownload": "Ocorreu algum erro com o download",
  "expandableCard.collapse": "Recolher",
  "expandableCard.expand": "Expandir",
  export: "Exportar",
  fee: V,
  file: w,
  "filter.date.since": "De %{date}",
  "filter.date.until": "Até %{date}",
  filterBar: E,
  "filterPlaceholder.category": "Tipo",
  "filterPlaceholder.currency": "Moeda",
  "filterPlaceholder.status": "Status",
  from: L,
  full: B,
  fundsCaptured: k,
  goBack: W,
  grantIssued: M,
  grantRepayment: U,
  hideContent: j,
  id: z,
  incompleteField: Y,
  inProgress: H,
  loading: _,
  max: G,
  min: X,
  mobile: Q,
  netPayout: J,
  nextPayouts: K,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ae,
  noTransactionsFound: oe,
  other: te,
  paginatedNavigation: ne,
  "pagination.nextPage": "Próxima página",
  "pagination.previousPage": "Página anterior",
  "pagination.showing": "Exibindo",
  partial: se,
  paymentId: re,
  paymentMethod: ie,
  payoutDetails: ce,
  payoutsNotice: de,
  payoutsTitle: le,
  Pending: ue,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: me,
  "rangePreset.custom": "Personalizado",
  "rangePreset.last30Days": "Últimos 30 dias",
  "rangePreset.last7Days": "Últimos 7 dias",
  "rangePreset.lastMonth": "Último mês",
  "rangePreset.lastWeek": "Semana passada",
  "rangePreset.thisMonth": "Este mês",
  "rangePreset.thisWeek": "Esta semana",
  "rangePreset.yearToDate": "Ano até o momento",
  reachOutToSupport: fe,
  referenceID: ge,
  refresh: he,
  refund: ve,
  "refund.amountAlreadyRefunded": "Você já reembolsou %{amount}",
  "refund.amountFailed": "O reembolso de %{amount} falhou. No momento, não é possível fazer o reembolso desse valor. Fale com o suporte.",
  "refund.amountInProgress": "O reembolso parcial de %{amount} está sendo processado.",
  "refund.fee": "Taxa",
  "refund.fullAmountFailed": "Não é possível reembolsar este pagamento. Fale com o suporte.",
  "refund.fullAmountRefunded": "O valor total foi reembolsado ao cliente",
  "refund.goToPayment": "Acesse o pagamento",
  "refund.maximumRefundable": "Você só pode reembolsar no máximo %{amount}",
  "refund.onlyRefundable": "Você só pode reembolsar %{amount}",
  "refund.originalAmount": "Valor original",
  "refund.originalPayment": "Método de pagamento original",
  "refund.paymentPspReference": "Referência PSP do pagamento",
  "refund.pspReference": "Referência PSP",
  "refund.refundFee": "Taxa de reembolso",
  "refund.refundPspReference": "Referência do PSP do reembolso",
  "refund.returnToRefund": "Retornar para o reembolso",
  "refund.theRefundIsBeingProcessed": "O reembolso está sendo processado.",
  refundAction: be,
  refundActionErrorSubtitle: ye,
  refundActionErrorTitle: Te,
  refundActionSuccessSubtitle: Ae,
  refundActionSuccessTitle: Re,
  refundAmount: Ce,
  "refundAmount.excess": "Você não pode exceder o valor disponível de %{amount}",
  "refundAmount.required": "Insira um valor de reembolso",
  "refunded.full": "Totalmente reembolsado",
  "refunded.partial": "Reembolsado parcialmente",
  refundNotice: Pe,
  refundPayment: Ne,
  refundReason: Oe,
  "refundReason.duplicate": "Duplicar",
  "refundReason.fraudulent": "fraudulento",
  "refundReason.issue_with_item_sold": "Problema com o item vendido",
  "refundReason.other": "Outros",
  "refundReason.requested_by_customer": "Solicitado pelo cliente",
  refundReference: xe,
  "refundReference.placeholder": "Insira a referência aqui",
  remainingAmount: Fe,
  report: Se,
  "reportsError.tooManyDownloads": "Não foi possível baixar todos os arquivos. Tente novamente mais tarde.",
  reportsNotice: De,
  reportsTitle: qe,
  "reportType.payout": "Liquidação de pagamento",
  reset: Ie,
  Reversed: Ve,
  "select.filter.placeholder": "Placeholder",
  "select.noOptionsFound": "A busca não retornou nenhuma opção",
  somethingWentWrong: we,
  somethingWentWrongTryRefreshingOrComeBackLater: Ee,
  status: Le,
  structuredList: Be,
  subtractions: ke,
  sumOfSameDayPayouts: We,
  tabs: Me,
  theErrorCodeIs: Ue,
  thereAreNoResults: je,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: ze,
  thereWasAnUnexpectedError: Ye,
  theSelectedBalanceAccountIsIncorrect: He,
  timezone: _e,
  to: Ge,
  "tooltip.ATM": "Dinheiro sacado em um caixa eletrônico",
  "tooltip.Capital": "Dinheiro recebido de um empréstimo ou enviado para pagamento de um empréstimo",
  "tooltip.Chargeback": "Dinheiro devolvido a um cliente após uma transação contestada",
  "tooltip.Correction": "Ajustes em seus fundos, incluindo reversões de transações e correções de depósitos",
  "tooltip.Fee": "Custos de transação e taxas de métodos de pagamentos",
  "tooltip.Other": "Transações que não estão em outra categoria, geralmente um ajuste",
  "tooltip.Payment": "Dinheiro recebido em sua conta de uma transação de vendas",
  "tooltip.Refund": "Dinheiro devolvido a um cliente após o reembolso de uma transação",
  "tooltip.totalIncoming": "Todo o dinheiro recebido em sua conta com base nos filtros selecionados",
  "tooltip.totalOutgoing": "Todas as taxas, os reembolsos, os repasses de pagamentos e outras cobranças com base nos filtros selecionados",
  "tooltip.Transfer": "Dinheiro transferido de sua conta para outra",
  totalIncoming: Xe,
  totalOutgoing: Qe,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Ke,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: ea,
  transfer: aa,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: oa,
  tryRefreshingThePageOrComeBackLater: ta,
  txAmount: na,
  "txType.ATM": "Caixa eletrônico",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Correção",
  "txType.Fee": "Taxa",
  "txType.Other": "Outros",
  "txType.Payment": "Pagamento",
  "txType.Refund": "Reembolso",
  "txType.Transfer": "Transferir",
  type: sa,
  value: ra,
  weCouldNotLoadThePayoutsOverview: ia,
  weCouldNotLoadTheReportsOverview: ca,
  weCouldNotLoadTheTransactionsOverview: da,
  weCouldNotLoadYourBalanceAccounts: la,
  weCouldNotLoadYourPayouts: ua,
  weCouldNotLoadYourReports: pa,
  weCouldNotLoadYourTransactions: ma
};
export {
  p as Booked,
  ue as Pending,
  Ve as Reversed,
  e as account,
  a as accountBalance,
  o as accountDescription,
  t as accountID,
  n as additions,
  s as adjustments,
  r as amount,
  i as and,
  c as apply,
  d as back,
  l as balanceAccount,
  u as balanceAccountId,
  m as capture,
  f as category,
  g as chargeback,
  h as closeIconLabel,
  v as contactSupport,
  b as contactSupportForHelp,
  y as contactSupportForHelpAndShareErrorCode,
  T as copied,
  A as copy,
  R as correction,
  C as currency,
  P as date,
  N as dateRange,
  fa as default,
  O as description,
  x as dismiss,
  F as download,
  S as downloading,
  D as email,
  q as entityWasNotFound,
  I as entityWasNotFoundDetail,
  V as fee,
  w as file,
  E as filterBar,
  L as from,
  B as full,
  k as fundsCaptured,
  W as goBack,
  M as grantIssued,
  U as grantRepayment,
  j as hideContent,
  z as id,
  H as inProgress,
  Y as incompleteField,
  _ as loading,
  G as max,
  X as min,
  Q as mobile,
  J as netPayout,
  K as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ae as noReportsFound,
  oe as noTransactionsFound,
  te as other,
  ne as paginatedNavigation,
  se as partial,
  re as paymentId,
  ie as paymentMethod,
  ce as payoutDetails,
  de as payoutsNotice,
  le as payoutsTitle,
  pe as pleaseComeBackLater,
  me as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  ge as referenceID,
  he as refresh,
  ve as refund,
  be as refundAction,
  ye as refundActionErrorSubtitle,
  Te as refundActionErrorTitle,
  Ae as refundActionSuccessSubtitle,
  Re as refundActionSuccessTitle,
  Ce as refundAmount,
  Pe as refundNotice,
  Ne as refundPayment,
  Oe as refundReason,
  xe as refundReference,
  Fe as remainingAmount,
  Se as report,
  De as reportsNotice,
  qe as reportsTitle,
  Ie as reset,
  we as somethingWentWrong,
  Ee as somethingWentWrongTryRefreshingOrComeBackLater,
  Le as status,
  Be as structuredList,
  ke as subtractions,
  We as sumOfSameDayPayouts,
  Me as tabs,
  Ue as theErrorCodeIs,
  ze as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  He as theSelectedBalanceAccountIsIncorrect,
  je as thereAreNoResults,
  Ye as thereWasAnUnexpectedError,
  _e as timezone,
  Ge as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  Qe as totalOutgoing,
  Ke as transactionDetails,
  ea as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  aa as transfer,
  oa as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  ta as tryRefreshingThePageOrComeBackLater,
  na as txAmount,
  sa as type,
  ra as value,
  ia as weCouldNotLoadThePayoutsOverview,
  ca as weCouldNotLoadTheReportsOverview,
  da as weCouldNotLoadTheTransactionsOverview,
  la as weCouldNotLoadYourBalanceAccounts,
  ua as weCouldNotLoadYourPayouts,
  pa as weCouldNotLoadYourReports,
  ma as weCouldNotLoadYourTransactions
};
